<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Appraisal Level</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" @change="show==false" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
                    </v-col>
                     <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>Instructor</b></p>
                        <v-autocomplete color="#0F2027" @change="show==false"  dense rounded required v-model="inst" :items="inst_list" item-text="name" item-value="id" label="Instructor" outlined persistent-hint hint="Please Select Instructor" />
                    </v-col>
                    
                </v-row>
                <v-row justify="center" dense v-if="ay && inst">
                    <v-btn class="button" @click="getReport()">Fetch</v-btn>
                </v-row>
                <apprisal-report v-if="show==true"></apprisal-report>
                <!-- <v-row justify="center" dense v-if="inst_data!=''">
                    <v-col cols="12" sm="3" md="3"><strong>Name :</strong>  {{inst_data.name}}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Employee Designation : </strong> {{ inst_data.inst_designation }} </v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Employee Type :</strong>  {{ inst_data.inst_employeetype }} </v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Date Of Joining :</strong> {{ inst_data.inst_date_of_joining }}</v-col>
                </v-row>
                <v-simple-table fixed-header dense class="elevation-1" height="500px" v-if="measurement_list!=''">
                     <thead>
                        <tr>
                            <th class="">Sr. No.</th>
                            <th class="">Areas</th>
                            <th v-for="a in apprisal_level_list" :key="a.id">{{a.name}}</th>
                            <th>Vice Principal/  Coordinator Score</th>
                            <th>Principal Score</th>
                            <th>Total Score</th>
                        </tr>
                     </thead>
                     <tbody v-for="(s, index) in measurement_list" :key="index">
                        
                            <td><strong>{{s.parameter_no}}</strong></td>
                            <td :colspan="apprisal_level_list.length+4"><strong>{{s.parameter_name}}</strong> </td>
                            <tr v-for="(s1, index1) in s.all_sub_parameter_list" :key="index1">
                               <td>{{s1.asp_no}}</td>
                               <td>{{s1.asp_name}}</td>
                               <td v-for="aspl,index in s1.asp_linking_level" :key="index">
                                    {{aspl.as_al_description}} <br>
                                    <input v-if="aspl.as_al_id" type="checkbox" v-model="aspl.as_al_checked"  @change="checkRadio(aspl.as_al_id,s1.asp_linking_level)" />
                               </td>
                               <td></td>
                               <td></td>
                               <td></td>
                            </tr>
                       
                     </tbody>
                </v-simple-table> -->
            </v-card>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import GetTeacherApprisalPerformanceMeasurementReport from './GetTeacherApprisalPerformanceMeasurementReport'
    export default {
          components:{
      'apprisal-report':GetTeacherApprisalPerformanceMeasurementReport,
    },
        data: () => ({
            show:false,
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            radios: null,
            criteria: "",
            ay_list: [],
            ay: "",
            inst_list:[],
            inst:null,
            measurement_list:[],
            inst_data:[],
            apprisal_level_list:[]
        }),
        methods: {
            checkRadio(as_al_id,asp_linking_level){
                for (let i = 0; i < asp_linking_level.length; i++) {
                    if (asp_linking_level[i].as_al_id != as_al_id) {
                       asp_linking_level[i].as_al_checked = false;
                    }
                    else{
                         asp_linking_level[i].as_al_checked = true;
                    }
                }
            },
            getReport(){
                localStorage.setItem("setay", this.ay);
                localStorage.setItem("setinst", this.inst);
                this.show = true
                // const data = {
                //     ay:this.ay,
                //     inst:this.inst
                // }
                //  axios
                //     .post("SelfAppraisal/getTeacherApprisalPerformanceMeasurementReport",data)
                //     .then((res) => {
                //         if (res.data.flag == "YES") {
                //             this.measurement_list = res.data.measurement_list
                //             this.inst_data = res.data.inst_data
                //             this.apprisal_level_list = res.data.apprisal_level_list
                //             this.overlay = false;
                //         } else {
                //             this.showSnackbar("red", res.data.snackbar);
                //             sessionStorage.setItem("error-trace", res.data.error_trace);
                //         }
                //     })
                //     .catch((error) => {
                //         this.showSnackbar("#b71c1c", "Something went wrong!!!");
                //         this.overlay = false;
                //     })
                //     .finally(() => {
                //         this.overlay = false;
                //     });
            },
            onLoad() {
                axios
                    .post("SelfAppraisal/teacherApprisalPerformanceMeasurementHome")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.ay_list = res.data.ay_list), (this.inst_list = res.data.inst_list), (this.ay = res.data.current_ay);
                            this.overlay = false;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
    /* .v-text-field{
      width: 80px;
} */
    thead {
        font-weight: bold !important;
    }
    th {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        /* text-align: center; */
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border: 1px solid black;
        font-size: small;
    }
    td {
        font-size: small;
    }
    .weaklyoff {
        background: white !important;
    }
    .weaklyoff2 {
        background: yellow !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        /* text-align: center; */
        font-size: small;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
